// メッセージMap
export const MessageMap = {
    "search_status_of_residence": "在留資格",
    "search_case_title": "案件名",
    "search_accept_period_start": "受入・就業期間（From）",
    "search_accept_period_end": "受入・就業期間（To）",
    "search_enquete_answer_status": "アクシデント",
    "search_score": "自動評価結果",
};